$bog_ui_sheet $mol_view
	showed? false
	side \right
	content /
	sub /
		<= Backdrop $mol_view
			event *
				click? <=> backdrop_click? null
		<= Panel $mol_view
			sub /
				<= Content $mol_list
					rows <= content
	attr *
		bog_ui_sheet_showed <= showed?
		bog_ui_sheet_side <= side
